(function () {
  var COOKIE_NAME = "kayer_pl_promo_confirmed";
  var LEGACY_COOKIE = "kayer_pl_promo_sub";
  var COOKIE_DAYS = 60;
  var DEBOUNCE_MS = 400;
  var MAX_AJAX_TRIES = 4;
  var REDIRECT_GUARD_KEY = "kayer_pl_promo_redirect_v1";

  var debounceTimer = null;
  var ajaxTries = 0;
  var applying = false;
  var redirectUsed = false;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function cartApiUrl(path) {
    if (typeof window.KayerCartApiUrl === "function") {
      return window.KayerCartApiUrl(path);
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    root = String(root);
    if (root.slice(-1) !== "/") root += "/";
    return root + String(path || "").replace(/^\//, "");
  }

  function isCartPage() {
    var path = (window.location.pathname || "").replace(/\/+$/, "") || "/";
    return path === "/cart" || /\/cart$/.test(path);
  }

  function getCookie(name) {
    try {
      var parts = document.cookie ? document.cookie.split("; ") : [];
      var prefix = name + "=";
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].indexOf(prefix) === 0) {
          return decodeURIComponent(parts[i].slice(prefix.length));
        }
      }
    } catch (err) {}
    return "";
  }

  function setCookie(name, value, days) {
    try {
      var maxAge = days * 24 * 60 * 60;
      var secure = window.location.protocol === "https:" ? "; Secure" : "";
      document.cookie =
        name +
        "=" +
        encodeURIComponent(value) +
        "; path=/; max-age=" +
        maxAge +
        "; SameSite=Lax" +
        secure;
    } catch (err) {}
  }

  function promoCode() {
    return getCookie(COOKIE_NAME);
  }

  function codeMatches(cart, code) {
    var want = String(code || "").toUpperCase();
    var list = cart && cart.discount_codes;
    if (list && list.length) {
      for (var i = 0; i < list.length; i++) {
        var row = list[i];
        var val =
          typeof row === "string"
            ? row
            : row && (row.code || row.discount_code || row.title);
        if (val && String(val).toUpperCase() === want) return true;
      }
    }
    return false;
  }

  function isNewsletterDiscount(app) {
    var title = (app && app.title ? app.title : "").toUpperCase();
    if (title.indexOf("15%") !== -1 || title.indexOf("10%") !== -1) return false;
    if (title.indexOf("B2B-EU-NET") !== -1 || title.indexOf("LOYALTY") !== -1) return false;
    return (
      title.indexOf("KAYERPL5") !== -1 ||
      title.indexOf("NEWSLETTER") !== -1 ||
      (title.indexOf("KAYER PL") !== -1 && (title.indexOf("-5%") !== -1 || title.indexOf("−5%") !== -1))
    );
  }

  function isPartnerCartMode() {
    return (
      (document.body && document.body.getAttribute("data-kayer-distributor-partner") === "1") ||
      !!document.querySelector('[data-kayer-distributor-partner="1"]') ||
      !!document.querySelector('[data-kayer-partner-pricing="1"]')
    );
  }

  function hasRedirectGuard() {
    if (redirectUsed) return true;
    try {
      return sessionStorage.getItem(REDIRECT_GUARD_KEY) === "1";
    } catch (err) {
      return false;
    }
  }

  function markRedirectGuard() {
    redirectUsed = true;
    try {
      sessionStorage.setItem(REDIRECT_GUARD_KEY, "1");
    } catch (err) {}
  }

  function clearRedirectGuard() {
    redirectUsed = false;
    try {
      sessionStorage.removeItem(REDIRECT_GUARD_KEY);
    } catch (err) {}
  }

  function hasForeignCartCodes(cart, code) {
    var want = String(code || "").toUpperCase();
    return cartDiscountCodeList(cart).some(function (c) {
      var u = String(c || "").toUpperCase();
      return u && u !== want;
    });
  }

  function productsSubtotalCents(cart) {
    if (typeof window.plCartProductsSubtotalCents === "function") {
      return window.plCartProductsSubtotalCents(cart);
    }
    var sum = 0;
    (cart.items || []).forEach(function (it) {
      if ((it.quantity || 0) > 0) sum += it.original_line_price || 0;
    });
    return sum;
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.moneyFormat) {
      return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    return (Number(cents) / 100).toFixed(2).replace(".", ",") + " zł";
  }

  /** Faktyczna kwota −5% newsletter — tylko z aplikacji o tytule newsletter, bez „cały gap brutto−total”. */
  function newsletterSavingsCents(cart, code) {
    var sum = 0;
    var apps = (cart && cart.cart_level_discount_applications) || [];
    var i;
    for (i = 0; i < apps.length; i++) {
      if (isNewsletterDiscount(apps[i])) {
        sum += parseInt(apps[i].total_allocated_amount, 10) || 0;
      }
    }
    if (sum > 0) return sum;
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (alloc) {
        var app = alloc.discount_application || {};
        if (isNewsletterDiscount(app)) {
          sum += parseInt(alloc.amount, 10) || 0;
        }
      });
    });
    return sum;
  }

  function discountLooksApplied(cart, code) {
    return codeMatches(cart, code) && newsletterSavingsCents(cart, code) > 0;
  }

  function codePendingInCart(cart, code) {
    return codeMatches(cart, code) && newsletterSavingsCents(cart, code) <= 0;
  }

  function findBanner() {
    return document.querySelector("[data-kayer-pl-cart-promo-banner]");
  }

  function showBanner(state, code, extra) {
    var root = document.querySelector("[data-section-type='cart']");
    if (!root) return;

    var box = findBanner();
    if (!box) {
      box = document.createElement("div");
      box.setAttribute("data-kayer-pl-cart-promo-banner", "");
      var h1 = root.querySelector("h1");
      if (h1 && h1.parentNode) {
        h1.parentNode.insertBefore(box, h1.nextSibling);
      } else {
        root.insertBefore(box, root.firstChild);
      }
    }

    var styles = {
      ok: "margin:0 0 1.25rem;padding:14px 16px;border-radius:14px;font-size:14px;line-height:1.5;background:#eef5e0;border:1px solid #d5e3b8;color:#2a3318;",
      wait: "margin:0 0 1.25rem;padding:14px 16px;border-radius:14px;font-size:14px;line-height:1.5;background:#f7f8e8;border:1px solid #e3e6c8;color:#1a1a1a;",
      err: "margin:0 0 1.25rem;padding:14px 16px;border-radius:14px;font-size:14px;line-height:1.5;background:#fff4f0;border:1px solid #f0d4c8;color:#4a2a22;",
    };
    box.style.cssText = styles[state] || styles.wait;

    if (state === "ok") {
      var saved = extra && extra.savingsCents ? formatMoney(extra.savingsCents) : "";
      box.innerHTML =
        "<strong>Masz −5% na newsletter</strong>" +
        (saved
          ? " — oszczędzasz <strong>" + saved + "</strong>."
          : ".") +
        ' <span style="display:block;margin-top:6px;font-weight:400;">Kwota „Do zapłaty” poniżej jest już po rabacie. Kod: <strong>' +
        code +
        "</strong>.</span>";
    } else if (state === "pending") {
      box.innerHTML =
        "<strong>Kod " +
        code +
        "</strong> jest w koszyku. " +
        (extra ||
          "Jeśli rabat nie widać w podsumowaniu, kod był już użyty albo nie łączy się z innymi zniżkami. Możesz iść do kasy.");
    } else if (state === "err") {
      box.innerHTML =
        "<strong>Nie udało się dodać rabatu −5%</strong> (kod " +
        code +
        "). " +
        (extra || "Odśwież koszyk lub wpisz kod przy kasie.") +
        ' <button type="button" data-kayer-pl-retry-discount style="margin-left:8px;padding:4px 10px;border-radius:8px;border:1px solid #ccc;background:#fff;cursor:pointer;">Spróbuj ponownie</button>';
      var btn = box.querySelector("[data-kayer-pl-retry-discount]");
      if (btn) {
        btn.addEventListener("click", function () {
          ajaxTries = 0;
          ensureDiscount(true);
        });
      }
    } else {
      box.innerHTML =
        "<strong>Dodajemy rabat −5% na newsletter</strong> (kod " + code + ")…";
    }
  }

  function refreshCartFooter(cart) {
    if (typeof window.kayerPlRenderCartFooter === "function") {
      window.kayerPlRenderCartFooter(cart);
      return;
    }
    var subEl = document.getElementById("CartSubtotal");
    if (subEl && cart && cart.total_price != null && window.theme && window.theme.Currency) {
      subEl.textContent = window.theme.Currency.formatMoney(
        cart.total_price,
        window.theme.moneyFormat
      );
    }
  }

  function syncBanner(cart, code) {
    var savings = newsletterSavingsCents(cart, code);
    if (savings > 0) {
      showBanner("ok", code, { savingsCents: savings });
      return;
    }
    if (codePendingInCart(cart, code)) {
      showBanner("pending", code);
      return;
    }
    showBanner("wait", code);
  }

  function fetchCart() {
    return fetch(cartApiUrl("cart.js"), { credentials: "same-origin" }).then(function (r) {
      return r.json();
    });
  }

  function cartDiscountCodeList(cart) {
    return (cart.discount_codes || [])
      .map(function (d) {
        if (!d) return "";
        if (typeof d === "string") return d;
        return d.code || d.discount_code || "";
      })
      .map(function (c) {
        return String(c || "").trim();
      })
      .filter(Boolean);
  }

  /** Merge — NIE zastępuj całego zestawu (inaczej zniknie B2B-EU-NET). */
  function applyDiscountAjax(code) {
    var want = String(code || "").trim();
    if (!want) return fetchCart();
    return fetchCart().then(function (cart) {
      var codes = cartDiscountCodeList(cart);
      var up = want.toUpperCase();
      if (!codes.some(function (c) { return c.toUpperCase() === up; })) {
        codes.push(want);
      }
      return fetch(cartApiUrl("cart/update.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ discount: codes.join(",") }),
      }).then(function (r) {
        if (!r.ok) throw new Error("update.js " + r.status);
        return r.json();
      });
    });
  }

  function publishCart(cart) {
    try {
      if (window.theme) window.theme.cartObject = cart;
    } catch (e) {}
    refreshCartFooter(cart);
    try {
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
    } catch (e2) {}
  }

  function redirectApply(code, cart) {
    if (hasRedirectGuard()) return false;
    if (hasForeignCartCodes(cart, code)) return false;
    markRedirectGuard();
    window.location.replace(
      "/discount/" + encodeURIComponent(code) + "?redirect=" + encodeURIComponent("/cart")
    );
    return true;
  }

  function handleCartState(cart, code, opts) {
    opts = opts || {};
    if (isPartnerCartMode()) return Promise.resolve(cart);

    if (discountLooksApplied(cart, code)) {
      ajaxTries = 0;
      clearRedirectGuard();
      setCookie(COOKIE_NAME, code, COOKIE_DAYS);
      publishCart(cart);
      syncBanner(cart, code);
      return Promise.resolve(cart);
    }

    // Code is already on the cart but Shopify allocated 0. Typical for
    // appliesOncePerCustomer or a clash with B2B-EU-NET. /discount/CODE
    // wipes other codes and reloads /cart forever (IT + logged-in).
    if (codePendingInCart(cart, code)) {
      refreshCartFooter(cart);
      syncBanner(cart, code);
      return Promise.resolve(cart);
    }

    if (applying) return Promise.resolve(cart);

    if (ajaxTries >= MAX_AJAX_TRIES) {
      showBanner("err", code);
      return Promise.resolve(cart);
    }

    applying = true;
    ajaxTries += 1;
    showBanner("wait", code);

    return applyDiscountAjax(code)
      .then(function () {
        return fetchCart();
      })
      .then(function (fresh) {
        applying = false;
        if (discountLooksApplied(fresh, code)) {
          ajaxTries = 0;
          clearRedirectGuard();
          setCookie(COOKIE_NAME, code, COOKIE_DAYS);
          publishCart(fresh);
          syncBanner(fresh, code);
          return fresh;
        }
        if (codePendingInCart(fresh, code)) {
          refreshCartFooter(fresh);
          syncBanner(fresh, code);
          return fresh;
        }
        if (opts.allowRedirect && !hasRedirectGuard() && !hasForeignCartCodes(fresh, code)) {
          redirectApply(code, fresh);
          return fresh;
        }
        showBanner("err", code);
        return fresh;
      })
      .catch(function () {
        applying = false;
        if (opts.allowRedirect && !hasRedirectGuard() && !hasForeignCartCodes(cart, code)) {
          redirectApply(code, cart);
          return null;
        }
        showBanner("err", code);
        return null;
      });
  }

  function ensureDiscount(immediate) {
    var code = promoCode();
    if (!code || !isCartPage() || isPartnerCartMode()) return;

    clearTimeout(debounceTimer);
    var run = function () {
      fetchCart().then(function (cart) {
        handleCartState(cart, code, {
          allowRedirect: !hasRedirectGuard() && ajaxTries === 0 && !hasForeignCartCodes(cart, code),
        });
      });
    };

    if (immediate) run();
    else debounceTimer = window.setTimeout(run, DEBOUNCE_MS);
  }

  function onCartUpdated(evt) {
    if (!isCartPage() || !promoCode() || isPartnerCartMode()) return;
    var cart = evt && evt.detail && evt.detail.cart;
    if (!cart) return;

    var code = promoCode();
    if (discountLooksApplied(cart, code) || codePendingInCart(cart, code)) {
      refreshCartFooter(cart);
      syncBanner(cart, code);
      return;
    }

    ensureDiscount(false);
  }

  ready(function () {
    if (!isCartPage()) return;

    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (err) {
      params = null;
    }
    if (params && params.get("kayer_no_discount") === "1") return;

    if (!promoCode()) return;

    if (getCookie(LEGACY_COOKIE) && !getCookie(COOKIE_NAME)) {
      try {
        document.cookie = LEGACY_COOKIE + "=; path=/; max-age=0; SameSite=Lax";
      } catch (err) {}
      return;
    }

    document.addEventListener("cart:updated", onCartUpdated);
    fetchCart().then(function (cart) {
      if (discountLooksApplied(cart, promoCode()) && typeof window.kayerPlRenderCartFooter === "function") {
        window.kayerPlRenderCartFooter(cart);
        syncBanner(cart, promoCode());
      }
    });
    ensureDiscount(true);
  });
})();
